import { Text } from '@amo/core/components/forms';
import { Field } from 'redux-form';
import {getTranslation} from "../../../utils/index.js";
import { validatePersonName } from "../../../utils/validateField.js";

export const NomNaissance = (props) => {
    const { index, disabled, required } = props;

    return (
        <div className={'row justify-content-center'}>
            <div className={'col-lg-8 col-md-6 col-sm-6 col-12 my-2'}>
                <Field
                    name={`DemandeTarif[ListePersonnes][${index}][BirthName]`}
                    label={index === 1 ? getTranslation('birthNameSubscriptor') : getTranslation('birthName')}
                    component={Text}
                    validate={[validatePersonName]}
                    type={'text'}
                    typeFormat={'text'}
                    disabled={disabled}
                    required={required}
                />
            </div>
        </div>
    );
};